
import { WeddingEventImageComment } from 'ignite360-core';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'comment',
})
export default class Comment extends Vue {
  @Prop({ required: true }) comment!: WeddingEventImageComment;
  @Prop({ required: true }) userSessionId!: string;
  @Prop({ required: false, default: false }) isAdmin!: boolean;

  deleteComment(commentId: string) {
    this.$emit('delete-comment', commentId);
  }

  approveComment(commentId: string) {
    this.$emit('approve-comment', commentId);
  }

  getFullDateTime(dateString: string | Date): string {
    const date = new Date(dateString);
    return date.toLocaleString('en-AU', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  }

  formatDate(dateString: string | Date): string {
    const date = new Date(dateString);
    const now = new Date();

    // Check if it's the current date
    const isToday = date.toDateString() === now.toDateString();

    if (isToday) {
      // If it's today, show time
      return date.toLocaleString('en-AU', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: false,
      });
    } else {
      // If not today, show date (and year if it's not current year)
      const isCurrentYear = date.getFullYear() === now.getFullYear();
      return date.toLocaleDateString('en-AU', {
        month: 'short',
        day: 'numeric',
        year: isCurrentYear ? undefined : 'numeric',
      });
    }
  }

  canDeleteComment(): boolean {
    return this.comment.userSessionId === this.userSessionId || this.isAdmin;
  }

  canApproveComment(): boolean {
    return this.comment.state === 'pending' && this.isAdmin;
  }

  isInApprovalMode(): boolean {
    return this.comment.state === 'pending' && !this.isAdmin;
  }
}
